import React from 'react';
import generateHreflang from 'lib/utils/generateHreflang';
import PATHS from 'lib/navigation/paths';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { mapNamedLocaleToLocale } from 'lib/data/localesMap';
import { defaultNS } from 'next-i18next.config';
import { BlogsViewV2 } from 'views/rebranded-module/blogs-module/BlogsViewV2';
import { HydrationWrapper } from 'views/common/components';
import { API } from 'lib/config/axios';
import isCrawlers from 'lib/utils/isCrawlers';
import { serverFetch } from 'lib/utils/serverFetch';
import { ContentContext } from 'views/rebranded-module/common/context/useContent';
import { useBlogsCMSData } from 'views/rebranded-module/blogs-module/BlogsViewV2/hooks/useBlogsCMSData';

const MotorcycleTouringPage = (props) => {
  const { serverData } = props;
  const content = useBlogsCMSData();
  return (
    <HydrationWrapper>
      <ContentContext.Provider value={content?.data}>
        <BlogsViewV2 serverData={serverData} />
      </ContentContext.Provider>
    </HydrationWrapper>
  );
};

export async function getServerSideProps(ctx) {
  const {
    locale, query, req, res, pathname,
  } = ctx;
  const ssrRender = isCrawlers(req.headers['user-agent']);

  if (query.force_old_page_load == 1) {
    res.statusCode = 503;
    return { props: {} };
  }

  let serverData = null;
  let layoutData = null;
  let serverError = null;

  if (ssrRender && pathname != '/_error') {
    const [layoutRes, blogsPageData] = await Promise.all([
      serverFetch(ctx, API.layout),
      serverFetch(ctx, API.blogsList),
    ]);
    if (layoutRes.success && layoutRes.data) {
      layoutData = layoutRes.data;
    } else {
      res.statusCode = 503;
      throw new Error('Rendering halted because we failed to load layout data');
    }
    if (blogsPageData.success && blogsPageData.data) {
      serverData = blogsPageData.data;
    } else {
      serverError = {
        statusCode: blogsPageData?.error?.response?.status,
      };
    }
  }
  if (serverError) {
    ctx.res.statusCode = serverError.statusCode;
  }
  const hreflangData = generateHreflang(
    PATHS.motorcycleTouring.index().url,
    locale,
  );
  return {
    props: {
      ...(await serverSideTranslations(mapNamedLocaleToLocale[locale], [
        ...defaultNS,
        'blogs_listing',
      ])),
      hreflangData,
      serverData,
      layoutData,
      ssrRender,
      serverError,
      rebrandingPage: true,
      options: {
        transparentNavBar: true,
        showAiChat: true,
      },
    },
  };
}
export default MotorcycleTouringPage;
